import { Navigate } from "react-router-dom";

export default function Diagnosis() {
  return <Navigate to="/home" replace />;
}
